import { render, staticRenderFns } from "./jobSoNo.vue?vue&type=template&id=71aef650&"
import script from "./jobSoNo.vue?vue&type=script&lang=js&"
export * from "./jobSoNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71aef650')) {
      api.createRecord('71aef650', component.options)
    } else {
      api.reload('71aef650', component.options)
    }
    module.hot.accept("./jobSoNo.vue?vue&type=template&id=71aef650&", function () {
      api.rerender('71aef650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/jobSoNo.vue"
export default component.exports